import { Token } from '@/api/token.js';
import Auth from '@/api/auth';

import { createNamespacedHelpers } from 'vuex';
import ConciergeDefs from '@/store/concierge/concierge.d';

import TabMenu from '@/components/tab_menu/TabMenu.vue';
import SideBar from '@/components/side_bar/SideBar.vue';
import DashboardDash from '@/components/dashboard_dash/DashboardDash.vue';
import DashboardMonthlyRecord from '@/components/dashboard_monthly_record/DashboardMonthlyRecord.vue';
import DashboardRewardsHistory from '@/components/dashboard_rewards_history/DashboardRewardsHistory.vue';

const {
  mapState: mapConciergeState,
  mapActions: mapConciergeActions
} = createNamespacedHelpers('Concierge');

export default {
  data: () => ({
    tabMenu: {
      items: {
        dash: {
          label: 'Dashboard'
        },
        monthlyRecord: {
          label: 'Monthly Record'
        },
        rewardsHistory: {
          label: 'Rewards History'
        }
      },
      currentTab: 'dash'
    }
  }),
  components: {
    TabMenu,
    SideBar,
    DashboardDash,
    DashboardMonthlyRecord,
    DashboardRewardsHistory
  },
  computed: {
    ...mapConciergeState({
      conciergeRewards: state => state.conciergeRewards
    })
  },
  created: async function() {
    const conciergeSession = Token.getConciergeSession();

    if (!conciergeSession) return;
    try {
      await this.conciergeStore_setConciergeRewards(
        conciergeSession.conciergeId
      );
    } catch (error) {
      // Handle error in case the local conciergeSession hold invalid token or expired token
      Auth.logoutConcierge();
    }
  },
  methods: {
    ...mapConciergeActions({
      conciergeStore_setConciergeRewards:
        ConciergeDefs.actions.setConciergeRewards
    })
  }
};
